import { forwardRef } from "react";

import { ListItemSeparator } from "./ListItemSeparator";

// Separator for when the a customer absence botflow is active
export const AutopilotActiveSeparator = forwardRef<HTMLDivElement>(function AutopilotActiveSeparator(_props, ref) {
    return <ListItemSeparator label="Bot will handle the chat until they reply" ref={ref} />;
});
